import React from 'react';
import { LocalPageTemplate } from '../components/LocalPageTemplate';
export function WebdesignHaarlemPage() {
  return <LocalPageTemplate cityName="Haarlem" region="Zuid-Kennemerland" introText="Een professionele website die past bij het karakter van jouw bedrijf in Haarlem. Wij bouwen websites die lokaal goed gevonden worden en direct nieuwe opdrachten opleveren." localContext="Haarlem combineert historische charme met een bruisend ondernemersklimaat. Van de gezellige horeca rond de Grote Markt tot de innovatieve bedrijven in de Waarderpolder: elke onderneming heeft een eigen verhaal. Wij vertalen dat verhaal naar een website die perfect aansluit bij jouw doelgroep in de regio Kennemerland." nearbyLocations={[{
    name: 'Heemstede',
    slug: 'heemstede'
  }, {
    name: 'Bloemendaal',
    slug: 'bloemendaal'
  }, {
    name: 'Zandvoort',
    slug: 'zandvoort'
  }]} faqs={[{
    q: 'Wat kost een website laten maken in Haarlem?',
    a: 'Voor een professionele, op maat gemaakte website in Haarlem start de investering vanaf €1.500. We bespreken altijd eerst jouw specifieke doelen en maken op basis daarvan een transparante offerte. Geen verborgen kosten achteraf.'
  }, {
    q: 'Werken jullie ook voor bedrijven in de Waarderpolder?',
    a: "Absoluut. We bouwen regelmatig websites voor B2B-bedrijven en productiebedrijven in de Waarderpolder. Voor deze bedrijven ligt de focus vaak op leadgeneratie, duidelijke dienstenpagina's en het uitstralen van autoriteit."
  }, {
    q: 'Helpen jullie ook met lokale vindbaarheid in Haarlem?',
    a: 'Ja, lokale SEO is een van onze specialiteiten. We zorgen dat je niet alleen gevonden wordt op je bedrijfsnaam, maar juist op de diensten die je aanbiedt in combinatie met Haarlem en omliggende plaatsen zoals Heemstede en Bloemendaal.'
  }]} data-id="element-2039" />;
}